import { __decorate, __metadata } from "tslib";
import { Serialize, Type } from '@ftr/serialization';
import { LocalDate, ZoneId } from '@js-joda/core';
/**
 * Represents a single location
 */
export class Location {
}
__decorate([
    Type(() => Location),
    __metadata("design:type", Object)
], Location.prototype, "parent", void 0);
__decorate([
    Type(() => Location),
    __metadata("design:type", Object)
], Location.prototype, "children", void 0);
__decorate([
    Serialize(() => ZoneId),
    __metadata("design:type", Object)
], Location.prototype, "timeZoneId", void 0);
__decorate([
    Serialize(() => LocalDate),
    __metadata("design:type", Object)
], Location.prototype, "trackIsolationInstallationDate", void 0);
